module.exports = __webpack_public_path__ + "img/human.d12ad84e.svg";